module.exports = __webpack_public_path__ + "static/media/resource-bg-1.a2d7436a.png";